(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s-sec-card-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSliders() {
    document.querySelectorAll('.s-sec-card-slider').forEach(function (section) {
      var track = section.querySelector('.s-sec-card-slider__track--slider');
      if (!track) return;

      var dots  = section.querySelectorAll('.s-sec-card-slider__hint-dot');
      var cards = track.querySelectorAll('.s-sec-card-slider__card');
      if (!dots.length || !cards.length) return;

      var tickId = null;

      function getActiveIndex() {
        var trackRect = track.getBoundingClientRect();
        var cx = trackRect.left + trackRect.width / 2;
        var closest = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var dist = Math.abs(r.left + r.width / 2 - cx);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        return closest;
      }

      function updateDots(active) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === active);
        });
      }

      track.addEventListener('scroll', function () {
        if (tickId) return;
        tickId = requestAnimationFrame(function () {
          tickId = null;
          updateDots(getActiveIndex());
        });
      }, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (cards[i]) {
            cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });

      updateDots(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  document.addEventListener('shopify:section:load', initSliders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-sec-media-dropdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.s-sec-md__btn');
      if (!btn) return;
      var item = btn.closest('.s-sec-md__item');
      var list = btn.closest('[data-s-sec-md-list]');
      if (!item || !list) return;
      var wasOpen = item.classList.contains('is-open');
      list.querySelectorAll('.s-sec-md__item').forEach(function (it) {
        it.classList.remove('is-open');
        var b = it.querySelector('.s-sec-md__btn');
        var p = it.querySelector('.s-sec-md__panel');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (p) p.hidden = true;
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        var panel = item.querySelector('.s-sec-md__panel');
        if (panel) panel.hidden = false;
      }
    });

    if (!customElements.get('s-sec-md-video')) {
      customElements.define('s-sec-md-video', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          requestAnimationFrame(function () {
            var video = self.querySelector('video');
            var btn = self.querySelector('.s-sec-md__play');
            if (!video) return;
            video.muted = true;
            video.setAttribute('muted', '');
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var setState = function () {
              var playing = !video.paused;
              self.classList.toggle('is-playing', playing);
              if (btn) btn.setAttribute('aria-label', playing ? btn.dataset.labelPause : btn.dataset.labelPlay);
            };
            if (self.dataset.autoplay === 'true' && !reduce) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
            video.addEventListener('play', setState);
            video.addEventListener('pause', setState);
            if (btn) btn.addEventListener('click', function () {
              if (video.paused) { video.play(); } else { video.pause(); }
            });
            setState();
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
